// import Vue from 'vue'
import axios from 'axios'
import store from '@/vuex/store'
import { VueAxios } from './axios'
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN } from "@/vuex/mutation-types"
import Router from '../router'
import {notificationConfig} from '../config/globalConfig'
import moment from 'moment'
// import {httpModel} from '../http/httpModel'


notification.config(notificationConfig)
// 创建 axios 实例
const service = axios.create({
  baseURL: '/',
  timeout: 30000
})

const err = (error) => {
  console.log(error)
  if (error.response) {
    let data = error.response.data
    const token = localStorage.getItem(ACCESS_TOKEN)
    const notify = (key) => {
      if (key == 401) {
        notification.error({
          key,
          message: '登录超时',
          description: '请重新登录验证',
        })
      }
    }
    if (error.response.status === 403) {
      notification.error({ message: '您无权访问该页面' })
      // Router.push('/home')
      Router.go(-1)
    }
    if(Router.history.current.path == '/login') {
      return Promise.reject(error)
    }
    if (error.response.status === 401) {
      notify(401)
      if (token) {
        store.dispatch('logout').then(() => {
          Router.push('/login')
          // notify()
        })
      } else {
        Router.push('/login')
        // notify()
      }
    }
    else{
      notification.error({ message: data.desc})
    }
    /*
    if (error.response.status === 500) {
      notification.error({ message: '服务器暂时无法响应', description: data.message})
    }
    */
  } else {
    notification.error({ message: '请求超时或网络连接错误！'})
  }
  return Promise.reject(error)
};

// request interceptor
service.interceptors.request.use(config => {
  // const token = Vue.ls.get(ACCESS_TOKEN)
  // console.log(config)
  config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  const lang = localStorage.getItem('lang') || 'zh-cn'
  const token = localStorage.getItem(ACCESS_TOKEN)
  const expire = localStorage.getItem('TOKEN_EXPIRE')
  // console.log(expire)
  if (token && expire && expire > 0 && moment().unix() > expire && config.url !== '/auth/v1.0/refreshToken') {
    // .. refresh token
    // 触发一个action去修改token
    store.dispatch('doRefreshToken', token)
    // httpModel.refreshToken(token).then((res) => {
    //   console.log(res)
    //   store.dispatch('setToken', {
    //     token: res.token,
    //     expire: res.expiration / 2 + moment().unix()
    //   })
    // })
  }
  if (token) {
    config.headers[ 'Authorization' ] = 'Bearer ' + token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  if (lang) {
    config.headers['lang'] = lang
  }
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
    return response.data
  }, err)

const installer = {
  vm: {},
  install (Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}